import { CommonModule } from '@angular/common';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { MaterialModule } from 'src/app/material.module';
import { UserModule } from 'src/modules/user/module';
import { UserApiService } from 'src/modules/user/services/user-api.service';
import { UsersDashboard } from './components/dashboard/component';
import { UserView } from './components/user/view/component';
import { DirectivesModule } from 'src/modules/directives/module';
import { NewUsersDashlet } from './components/dashlet/new-users/component';
import { RouterModule } from '@angular/router';
import { DataCleanse } from './components/data-cleanse/component';
import { DeleteAccountConfirm } from './components/delete-account-confirm/component';
@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    UserModule,
    RouterModule,
    DirectivesModule,
  ],
  declarations: [
    UsersDashboard,
    NewUsersDashlet,
    UserView,
    DataCleanse,
    DeleteAccountConfirm,
  ],
  exports: [UsersDashboard, NewUsersDashlet, DirectivesModule, DataCleanse],
  providers: [UserApiService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class UserAdminModule {}
